module.exports = __webpack_public_path__ + "static/media/banner.973b6aaa.svg";